module.exports = __webpack_public_path__ + "static/media/delete.0f24ab05.svg";